export enum ModalSize { 
  large = 'lg',
  xtraLarge = 'xl',
  default = 'md'
}

export enum ModalType {
  caseViewModal = 'caseView'
}
